// extracted by mini-css-extract-plugin
module.exports = {"flex":"confirmationDialog_flex__2dS2S"};